







































import Vue from "vue";
import defaultData from "@/assets/default.json";

export default Vue.extend({
    data: () => ({
        languages: [{
            title: "中文",
            locale: "zh"
        }, {
            title: "English",
            locale: "en"
        }],
    }),
    methods: {
        switchLanguage(locale: string) {
            this.$i18n.locale = locale;
        },
        upload(e) {
            let reader = new FileReader();
            reader.readAsText(e.target.files[0]);
            reader.onload = (event) => {
                window.setTimeout(() => {
                    this.$eventbus.$emit("fileUploaded", JSON.parse(event.target.result.toString()));
                    this.$forceUpdate();
                }, 10);
            };
            this.$router.push("annotate").catch(_ => {
            });
        },
        download() {
            this.$eventbus.$emit("downloadRequest");
        },
        downloadSVG() {
            this.$eventbus.$emit("downloadSVGRequest");
        },
        useDefault() {
            window.setTimeout(() => {
                this.$eventbus.$emit("fileUploaded", defaultData);
                this.$forceUpdate();
            }, 10);
            this.$router.push("annotate").catch(_ => {
            });
        }
    }
});
